export default __webpack_public_path__ + "static/arrow_left-714cd5ee2ce04c78ba9ba57c030f3ee7.png";